<template>
  <van-calendar
    ref="calendarRef"
    v-bind="$attrs"
    :title="title"
    :confirm-text="confirmText"
    :confirm-disabled-text="confirmDisabledText"
    :show-confirm="showConfirm"
  >
    <!-- 透传所有插槽到内部组件 -->
    <template v-for="(_, name) in $slots" #[name]="slotData" :key="name">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </van-calendar>
</template>

<script setup>
// 配置选项
defineOptions({
  inheritAttrs: false,
})

// 定义 Props，提供默认值
const props = defineProps({
  title: {
    type: String,
    default: 'Calendário',
  },
  confirmText: {
    type: String,
    default: 'Confirmar',
  },
  confirmDisabledText: {
    type: String,
    default: 'Confirmar',
  },
  showConfirm: {
    type: Boolean,
    default: true,
  },
})

const calendarRef = ref()

defineExpose({
  getInstance: () => calendarRef.value,
  reset: () => calendarRef.value?.reset,
})
</script>
